import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  IconButton
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import _ from 'lodash';
import Select from 'react-select';
import { useDispatch } from 'react-redux';

import config from '../../../../config/config.json';
import OrderContext from '../../../../context/orderContext';
import { setCustomerType, changeCustomer } from '../../../../store/ticket';

const useStyles = makeStyles(theme => ({}));

const Customers = props => {
  const { onCustomerChange, ticketId } = props;
  const orderContext = useContext(OrderContext);
  const dispatch = useDispatch();

  const classes = useStyles();
  // console.log('isEdit',isEdit);

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.id]: event.target.value
    });
  };

  const personTypes = config.personTypes;
  // [
  //   {
  //     value: 0,
  //     label: 'Участник'
  //   },
  //   {
  //     value: 1,
  //     label: 'Сотрудник'
  //   },
  // ];
  const [personType, setPersonType] = React.useState(0);

  const [values, setValues] = useState({
    name: null,
    type: 0
  });

  // настройки Select
  const [options, setOptions] = useState([]);
  const state = {
    selectedOption: null
  };

  const [saveState, setSaveState] = useState(true);

  // Начальная загрузка данных с сервера со список людей
  useEffect(() => {
    // console.log('props.users.selected', props.users);
    setOptions(props.users.users);

    if (props.users.ticketUserId) {
      const selectedOption = _.filter(props.users.users, [
        'value',
        props.users.ticketUserId
      ]);
      setValues({
        type: props.users.ticketUserType,
        name: selectedOption[0]
      });
    }

    // console.log('useEffect props.users',props.users);
    //  Передаем во внешний компонент что все готово
    if (!_.isEmpty(props.users)) {
      if (props.users.users.length > 0) {
        props.setPageReady(true);
      }
    }
    // const randoms = [...Array(1000)].map(() => Math.floor(Math.random() * 900000000));
    // setOptions(randoms.map((v,index) => { return {value: index, label: v} } ))
    // Инициализируем состояние начальное состояние кнопок для редактрования
    if (orderContext.actionType === 'edit') {
      setSaveState(false);
    }
  }, [props.users]);

  const handleSelectChange = selectedOption => {
    setValues({
      type: selectedOption.type,
      name: selectedOption
    });
    // console.log('selectedOption',selectedOption);
  };

  // Обработчик нажатия кнопки
  const handleAddCustomer = async () => {
    // console.log('handleAddCustomer', values)
    if (values.amount <= 0) return;
    if (values.name === null) return;

    if (orderContext.actionType === 'edit' && ticketId) {
      await dispatch(changeCustomer(ticketId, values.name.value, values.type));
    }

    onCustomerChange(values);
    setSaveState(false);
    // console.log('handleAddCustomer values',values);
    await dispatch(setCustomerType({ customerType: values.type }));
  };

  const handleEditCustomer = () => {
    setSaveState(true);
  };

  return (
    <Card
      style={{ overflow: 'visible' }}
      // {...rest}
      // className={clsx(classes.root, className)}
    >
      <form autoComplete="off" noValidate>
        <CardHeader title="Участники" />
        <Divider />
        <CardContent style={{ overflow: 'visible' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="stretch"
                spacing={3}>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    spacing={2}>
                    <Grid item xs={7} style={{ overflow: 'visible' }}>
                      {/* <TextField
                        fullWidth
                        id="name"
                        label="Фамилия"
                        margin="dense"
                        name="Фамилия"
                        onChange={handleChange}
                        required
                        value={values.name}
                        variant="outlined"
                      /> */}

                      <Select
                        value={values.name}
                        onChange={handleSelectChange}
                        options={options}
                        // isDisabled={!saveState || orderContext.actionType === 'edit' }
                        isDisabled={!saveState}
                        // isDisabled={isEdit }
                      />
                    </Grid>

                    {/* <Grid
                      item
                      xs={1}
                    >

                      <TextField
                        fullWidth
                        // label="Кол"
                        id="amount"
                        value={values.amount}
                        onChange={handleChange}
                        margin="dense"
                        variant="outlined"
                        disabled={!saveState}
                        />

                    </Grid> */}

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        disabled={!saveState}
                        // disabled={!saveState || orderContext.actionType === 'edit' }
                        select
                        label="Тип"
                        id="type"
                        value={values.type}
                        onChange={handleChange}
                        SelectProps={{
                          native: true
                        }}
                        margin="dense"
                        variant="outlined">
                        {personTypes.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={2}>
                      {saveState && (
                        <IconButton
                          aria-label="Save"
                          className={classes.margin}
                          color="primary"
                          onClick={handleAddCustomer}>
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      )}

                      {!saveState && (
                        <IconButton
                          aria-label="Edit"
                          className={classes.margin}
                          color="primary"
                          onClick={handleEditCustomer}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid
                  item
                  xs={12}
                >
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                    spacing={3}
                  >
                    <Grid
                      item
                      xs={6}
                    >
                      <TextField
                        disabled={true}
                        fullWidth
                        label="Фамилия"
                        margin="dense"
                        name="firstName"
                        onChange={handleChange}
                        required
                        value={values.firstName}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={1}
                    >
                      <TextField
                        fullWidth
                        // label="Кол"
                        disabled={true}
                        value={1}
                        onChange={handleChange}
                        margin="dense"
                        variant="outlined"
                      />
                    </Grid>


                    <Grid
                      item
                      xs={3}
                    >
                      <TextField
                        disabled={true}

                        fullWidth
                        select
                        label="Тип"
                        value={personType}
                        onChange={handleChange}
                        SelectProps={{
                          native: true,
                        }}
                        margin="dense"
                        variant="outlined"
                      >
                        {personTypes.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>

                    </Grid>




                    <Grid
                      item
                      xs={2}
                    >
                      <IconButton aria-label="edit" className={classes.margin} color="primary">
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton aria-label="delete" className={classes.margin} color="primary">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </form>
    </Card>
  );
};

export default Customers;
